import { render } from "./PaymentCard.vue?vue&type=template&id=3e66e585"
import script from "./PaymentCard.vue?vue&type=script&lang=js"
export * from "./PaymentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__